<div class="wrapper" (mouseenter)="hover = true" (mouseleave)="hover = false" [ngClass]="{'mat-elevation-z8 on-hover': hover}">
    <mat-icon>{{ icon }}</mat-icon>
    <h3 class="mat-title">{{ title }}</h3>
</div>